import React from 'react'
import { AccountRegisterContainer } from '../../../components/AccountRegisterContainer'
import { Link } from 'react-router-dom'
import { routesDef } from '../../../config/routes'
import { Form } from './Form'
import { LoginButton } from '@ztechapps/webui.auth'
import { BusyButton } from '@ztechapps/webui.button'
import { ButtonGroup } from 'react-bootstrap'
import { useHistory } from '@ztechapps/common.hook'
import { PageTitle } from '../../../components/PageTitle'

export const Layout = () => {
  const history = useHistory()
  return (
    <AccountRegisterContainer>
      <PageTitle
        title="Create Account"
        description="Create an account to save your preferences, track orders, and access exclusive features."
      />
      <div>
        <header className="mb-4">
          <h4>Register account</h4>
        </header>

        <ButtonGroup>
          <BusyButton
            icon={'arrow-left'}
            text="Back to Login"
            onClick={() => history.push(routesDef.LoginPage.altPath())}
          />
          <LoginButton uri={`/api/auth/google/pp-store`} text="Register using Google" />
        </ButtonGroup>

        <hr />
        <Form />
      </div>

      <p className="text-center  ">
        Have an account? <Link to={routesDef.LoginPage.altPath()}>Log In</Link>
      </p>
    </AccountRegisterContainer>
  )
}
